module.exports = "https://www.gc-qa.gnp.com.mx/ef4950d26811e9e400a577585d50647d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/contacto-icono.svg
// module id = 1811
// module chunks = 0